// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const postReportApi = baseApi.injectEndpoints({
  reducerPath: "postReportApi",
  endpoints: (builder) => ({
    updateReportPost: builder.mutation({
      query: (modifiedData) => {
        return {
          url: `admin/reports/${modifiedData.id}`,
          method: "PUT",
          body: modifiedData,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),

    getAllReportPosts: builder.query({
      query: ({page, limit}) => {
        return {
          url: `admin/reports?page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllReportPostsQuery, useUpdateReportPostMutation } =
  postReportApi;
